import Clock from '@assets/icons/clock.svg'
import { Icon } from './Icon'

export const ClockIcon = Icon(Clock)
